import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import { mobile } from "@ui/styles/utils";
import { PrimaryMedium } from "@ui/components/containers/primary";
import { Stack } from "@ui/components/layout";
import { ApplicationFileInformation } from "@ui/components/application/applicationFileInformation";
import { ApplicationInformationContainer } from "@ui/components/application/applicationInformationContainer";
import { SummaryViewProps } from "@ui/components/application/summaryView";

export const DocumentSectionSummaryView: React.FC<SummaryViewProps> = ({ application, ...htmlProps }) => {
	return (
		<Stack gap={20} style={{ width: "100%" }} {...htmlProps}>
			<ApplicationInformationContainer isDocument>
				<StyledPrimaryMedium>{I18n.t(`application.form.identity.label`)}</StyledPrimaryMedium>
				<ApplicationFileInformation>{application.idPassport?.displayName}</ApplicationFileInformation>
			</ApplicationInformationContainer>
			<ApplicationInformationContainer isDocument>
				<StyledPrimaryMedium>{I18n.t(`application.form.residency.label`)}</StyledPrimaryMedium>
				<ApplicationFileInformation>{application.proofResidence?.displayName}</ApplicationFileInformation>
			</ApplicationInformationContainer>
			<ApplicationInformationContainer isDocument>
				<StyledPrimaryMedium>{I18n.t(`application.form.diploma.label`)}</StyledPrimaryMedium>
				<ApplicationFileInformation>{application.diploma?.displayName}</ApplicationFileInformation>
			</ApplicationInformationContainer>
			<ApplicationInformationContainer isDocument>
				<StyledPrimaryMedium>{I18n.t(`application.form.transcript_diploma.label`)}</StyledPrimaryMedium>
				<ApplicationFileInformation>{application.transcriptRecord?.displayName}</ApplicationFileInformation>
			</ApplicationInformationContainer>
			<ApplicationInformationContainer isDocument>
				<StyledPrimaryMedium>{I18n.t(`application.form.work_certificate.label`)}</StyledPrimaryMedium>
				<ApplicationFileInformation>{application.workCertificate?.displayName}</ApplicationFileInformation>
			</ApplicationInformationContainer>
			<ApplicationInformationContainer isDocument>
				<StyledPrimaryMedium>{I18n.t(`application.form.resume.label`)}</StyledPrimaryMedium>
				<ApplicationFileInformation>{application.resume?.displayName}</ApplicationFileInformation>
			</ApplicationInformationContainer>
			<ApplicationInformationContainer isDocument>
				<StyledPrimaryMedium>{I18n.t(`application.form.financial_declaration.label`)}</StyledPrimaryMedium>
				<ApplicationFileInformation>{application.selfDeclarationFinancialNeed?.displayName}</ApplicationFileInformation>
			</ApplicationInformationContainer>
			{application.englishCertificat && (
				<ApplicationInformationContainer isDocument>
					<StyledPrimaryMedium>{I18n.t(`application.form.english_certificate.label`)}</StyledPrimaryMedium>
					<ApplicationFileInformation>{application.englishCertificat?.displayName}</ApplicationFileInformation>
				</ApplicationInformationContainer>
			)}
		</Stack>
	);
};

const StyledPrimaryMedium = styled(PrimaryMedium)`
	@media ${mobile} {
		font-size: 0.7rem;
	}
`;
